module.exports = __webpack_public_path__ + "assets/close.769b7fa6b1613a25bfd1b700fcb47478.png";